import contentRequest from '~/src/api/requests/contentRequest';

/**
 * Покупка товара
 * @param {String} domain
 * @param {String} token
 * @param {Number} itemId
 * @param {String} [priceType]
 * @param {Number} [leasingDuration]
 */
export async function buyItem(domain, token, itemId, priceType, leasingDuration) {
    return contentRequest.post(`${domain}/v1/shop-item/buy`, {
        id: itemId,
        price_type: priceType,
        leasing_duration: leasingDuration
    }, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(response => {
        return response.data;
    }).catch(error => {
        throw Error(error.response?.data?.message || error.message);
    });
}

export async function requestItems(domain, token) {
    return contentRequest.get(`${domain}/v1/shop-item?expand=category`,  {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(response => {
        return response;
    });
}

/**
 * @deprecated use ~/src/api/content/shop/getShopItems.ts
 * @param domain
 * @param token
 * @returns {Promise<*>}
 */
export async function requestRouters(domain, token) {
    return contentRequest.get(`${domain}/v1/shop/items?category=routers&expand=category,props,labels`,  {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(response => {
        return response;
    })
    .catch(err => console.log(err));
}

/**
 * @deprecated use ~/src/api/content/shop/getShopItems.ts
 * @param domain
 * @param token
 * @returns {Promise<*>}
 */
export async function requestSpeedBonuses(domain, token) {
    return contentRequest.get(`${domain}/v1/shop/items?category=speed-bonuses&expand=category`,  {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(response => {
        return response;
    })
    .catch(err => console.log(err));
}

/**
 * @deprecated use ~/src/api/content/shop/getShopItems.ts
 * @param domain
 * @param token
 * @returns {Promise<*>}
 */
export async function requestAntiviruses(domain, token) {
    return contentRequest.get(`${domain}/v1/shop/items?category=antiviruses&expand=category,props`,  {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(response => {
        return response;
    })
    .catch(err => console.log(err));
}

/**
 * @deprecated use ~/src/api/content/shop/getShopItems.ts
 * @param domain
 * @param token
 * @returns {Promise<*>}
 */
export async function requestIntercomServices(domain, token) {
    return contentRequest.get(`${domain}/v1/shop/items?category=intercom&expand=category,props`,  {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(response => {
        return response;
    })
    .catch(err => console.log(err));
}

export async function buySaleItem(domain, token, itemId) {
    return contentRequest.post(`${domain}/v1/shop-item/buy`, {
        id: itemId,
    }, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(response => {
        return response.data;
    });
}

/**
 * Приобретение партнерского сервиса
 * @param {String} domain
 * @param {String} token
 * @param {String | Number} id
 * @param {Object} phone
 * @param {number | undefined} flag_id
 */
export async function purchaseAdditionalServices(domain, token, id, phone, flag_id) {
    return contentRequest
        .post(
            `${domain}/v1/shop-item/buy`,
            {
                id: id,
                ...phone,
                flag_id,
            },
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            }
        )
        .then(response => {
            return response.data;
        })
        .catch(error => {
            let message;

            if (error.response?.status === 401) {
                message = 'Необходимо авторизоваться';
            } else if (error.response?.data?.message) {
                message = error.response.data.message;
            } else {
                console.log(error);
                message = 'Произошла ошибка. Мы уже ей занимаемся!';
            }

            throw new Error(message);
        });
}
